import React, { useState } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import PrintRoundedIcon from "@mui/icons-material/PrintRounded";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import StepImpresoras from "./StepImpresoras";
import StepWorker from "./StepWorker";

// Wizard · Step "Hardware" agrupador. Impresoras + Worker en tabs.
// Ambos son configuración de dispositivos físicos y estaban como
// steps separados innecesariamente — la mayoría de usuarios los
// tocan juntos o se los saltan juntos.

const TABS = [
  { key: "impresoras", label: "Impresoras", icon: <PrintRoundedIcon fontSize="small" />, component: StepImpresoras },
  { key: "worker", label: "Worker", icon: <DownloadRoundedIcon fontSize="small" />, component: StepWorker },
];

export default function StepHardware({ progress, onComplete, onSkip }) {
  const [tab, setTab] = useState("impresoras");
  const Active = TABS.find((t) => t.key === tab)?.component || StepImpresoras;

  // "Continuar"/"Saltar" avanzan de tab en tab; solo cierran el step
  // wrapper cuando estamos en la última tab (Worker).
  const currentIdx = TABS.findIndex((t) => t.key === tab);
  const isLastTab = currentIdx === TABS.length - 1;
  const handleInnerComplete = (extra) => {
    if (!isLastTab) return setTab(TABS[currentIdx + 1].key);
    onComplete?.(extra);
  };
  const handleInnerSkip = () => {
    if (!isLastTab) return setTab(TABS[currentIdx + 1].key);
    onSkip?.();
  };

  return (
    <Box>
      <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
        Impresoras y Worker
      </Typography>
      <Typography sx={{ color: "text.secondary", mb: 3 }}>
        Configura tus impresoras (comandera de barra, cocina, ticket cliente)
        y descarga el Worker si vas a imprimir en local. Todo es opcional —
        puedes hacerlo después desde el portal.
      </Typography>

      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        variant="fullWidth"
        sx={{ mb: 3, borderBottom: 1, borderColor: "divider" }}
      >
        {TABS.map((t) => (
          <Tab
            key={t.key}
            value={t.key}
            icon={t.icon}
            iconPosition="start"
            label={t.label}
            sx={{ fontWeight: 700, minHeight: 48 }}
          />
        ))}
      </Tabs>

      <Active
        progress={progress}
        onComplete={handleInnerComplete}
        onSkip={handleInnerSkip}
      />
    </Box>
  );
}
